<template>
    <div id="cart-actions" class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
        <div v-if="orderMeta.canOrder && product.SYSTEM" class="alert alert-info">
            <p>
                <em>{{labels[1739]}}</em>
                <!-- label: Our systems are customized to meet your specific needs -->
            </p>
            <br>
            <a
                class="btn btn-primary btn-sm btn-block gaq pop"
                :rel="'id:275|title:'+labels[201]+'|t:'+getURLVar('a')+'|b:'+getURLVar('b')+'|width:800px'"
                :href="'/'+getPageUrl(-11)+'?u='+getPageVar('urlterm')"
                :data-track="'questions|questions_ask_open|'+getPageVar('urlterm')">{{labels[1738]}}</a>
            <!-- label: Request System -->
        </div>

        <div v-else class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <br class="visible-xs visible-sm" />
                <div class="add">
                    <p v-if="quoteOnly && !product.OUTOFSTOCK" id="quote-helper">
                        <i class="small csi-iconfont csi-reply rotate"></i>
                        {{labels[1384]}}
                        <!-- label: Add to your Quote List -->
                    </p>

                    <button
                        v-if="!product.RETIRED && product.PROD_QQUOTE && !product.OUTOFSTOCK"
                        @click="transitionButton"
                        class="btn btn-primary btn-sm btn-block">{{labels[1176]}} 
                        <!-- Add --></button>

                    <button
                        v-else-if="product.RETIRED || !product.PROD_QQUOTE && !product.OUTOFSTOCK"
                        @click="window.loadLabel(1381);"
                        class="btn btn-sm btn-block">
                        {{labels[1177]}}<!-- Call -->
                    </button>

                    <p v-if="product.OUTOFSTOCK" class="alert alert-info icon small">
                        {{labels[2520]}}
                        <!-- label: Add to your Quote List -->
                    </p>

                    <br>
                </div>
                <a
                    v-if="buttonState != 'init'"
                    :href="'/'+getPageUrl(200)"
                    class="btn btn-sm btn-block"
                    :class="{'text-info': buttonState == 'added','btn-info': buttonState == 'cart'}">
                    <i class="csi-iconfont csi-ok hidden-md"></i>
                    <span v-if="buttonState == 'added'">{{labels[1552]}}</span>

                    <i v-if="buttonState == 'cart'" class="csi-iconfont csi-cart"></i> &nbsp;
                    <span v-if="orderMeta.canOrder && buttonState == 'cart'">{{labels[1137]}}</span>
                    <span v-else-if="buttonState == 'cart'">{{labels[1138]}}</span>
                </a>
            </div>
        </div>
        <div v-if="orderMeta.canOrder && !product.PROD_PURCHASE" class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <br>
                <div class="alert alert-info">
                    <i class="csi-iconfont csi-attention normal"></i>Not
                    available for online orders.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import useCMS from '../../shared/composables/useCMS';
import useProductInfo from '../composables/useProductInfo';
import useProductConfig from '../composables/useProductConfig';
import { ref, computed } from '@vue/composition-api';

export default {
    name: "orderActions",
    setup: function (props) {
        const { labels, getPageUrl, getPageVar, getURLVar } = useCMS();
        const { orderMeta } = useProductInfo();
        const { addToCart } = useProductConfig();
        const buttonState = ref('init');
        const quoteOnly = computed(() => props.main &&
            !props.product.RETIRED &&
            props.product.PROD_QQUOTE &&
            !orderMeta.value.hasProducts &&
            !orderMeta.value.canOrder)
        return {
            labels,
            orderMeta,
            addToCart,
            getPageUrl,
            getPageVar,
            buttonState,
            quoteOnly,
            getURLVar
        }
    },
    props: {
        product: {
            ID: Number,
            PROD_ITEMNO: String,
            RETIRED: Boolean,
            PROD_QQUOTE: Boolean,
            SYSTEM: Boolean,
            PROD_PURCHASE: Boolean
        },
        main: Boolean
    },

    methods: {
        transitionButton: function () {
            this.buttonState = 'added'; //Preemptively say it was added.
            var vm = this;
            this.addToCart({
                id: this.product.ID,
                prod_itemno: this.product.PROD_ITEMNO,
                model: this.PROD_MODEL,
                config: this.PROD_CONFIG
            }).then(function (response) {
                if (response.data.status == 200) {
                    setTimeout(function () {
                        vm.buttonState = 'cart';
                    }, 500);
                } else if (response.data.status == 400) {
                    vm.buttonState = 'init';
                } else {
                    vm.buttonState = 'init';
                    //jQuery UI
                    window.$('body').append('<div id="badProduct" class="popbox"></div>');
                    window.$('#badProduct').html(response.data.msg);
                    window.$('#badProduct').dialog({
                        title: response.data.title,
                        stackable: true,
                        modal: true,
                        position: {
                            collision: "none",
                            at: "center center"
                        },
                        width: 420,
                        height: 260,
                        beforeClose: function () {
                            window.$('#badProduct').dialog('destroy').remove();
                        },
                        buttons: [{
                            text: response.data.btnok,
                            click: function () {
                                window.$(this).dialog("close");
                            }
                        }]
                    });
                }
            });
        }
    }
}
</script>
